import { BaseMetaColumn } from "./BaseMetaColumn";
import { BaseMetaTable } from "./BaseMetaTable";
import { EncodingOperation } from "./EncodingOperation";
import { ErrorOperation } from "./ErrorOperation";

export class SortItem
{
    public table: BaseMetaTable;
    public column: BaseMetaColumn;
    public ascending: boolean;
    public static encode(sorts: SortItem[] | null): string
    {
        let value = this.stringify(sorts);
        return EncodingOperation.Base64Encode(value);
    }
    public static decode(value: string): SortItem[] | null
    {
        let encoded = EncodingOperation.Base64Decode(value);
        return this.parse(encoded);
    }
    public static stringify(sorts: SortItem[] | null): string
    {
        if (sorts)
            return sorts.map(x => x.getCommand()).join(";");
        return "";
    }
    public static parse(item: string | null): SortItem[]
    {
        let ans: SortItem[] = [];
        if (item)
        {
            let index = 0;
            let items = item.split(/(?<!\\);/);
            let thereIsMore = (): boolean =>
            {
                return index < items.length;
            };
            let next = (name: string): string =>
            {
                if (thereIsMore())
                    return items[index++];
                throw ErrorOperation.getHTTP(400, `Next value is required for '${name}'. Must be separated by ;`);
            };
            while (thereIsMore())
            {
                let value_table = next("Table");
                let table = new BaseMetaTable(null, value_table, value_table);

                let value_column = next("Column");
                let column = new BaseMetaColumn(table, value_column, value_column, "", false)

                let value_asc = next("Asending").toLowerCase();
                let asc = value_asc === "asc"
                if (value_asc != "asc" && value_asc != "desc")
                    ErrorOperation.throwHTTP(400, `Invalid value '${value_asc}' for SortItem.Asending, Only 'Asc' and 'Desc' are allowed.`);

                ans.push(new SortItem(table, column, asc));
            }
        }
        return ans;
    }
    constructor(table: BaseMetaTable, column: BaseMetaColumn, ascending: boolean)
    {
        this.table = table;
        this.column = column;
        this.ascending = ascending;
    }
    getCommand()
    {
        return [this.table.name, this.column.name, this.ascending ? "asc" : "desc"].join(";");
    }
    toString()
    {
        let ans = [];
        if (this.table.text)
            ans.push(this.table.text);
        else
            ans.push(this.table.name);
        if (this.column.text)
            ans.push(this.column.text);
        else
            ans.push(this.column.name);
        if (this.ascending)
            ans.push("Ascending");
        else
            ans.push("Descending");
        return ans.filter(x => x).join(" ");
    }
}